import { FC } from "react";
import BookingSummary from "../components/BookingSummary";
import HotelDetailsCard from "../components/HotelDetailsCard";
import HotelPoliciesCard from "../components/HotelPoliciesCard";
import HotelPaymentDrawer from "../components/HotelPaymentDrawer";
import { getHotelBookingSummaryCardData, hotelOrderDataMap } from "../constants";
import { HotelTransactionDetailsLayoutProps } from "./types";

const HotelTransactionDetailsMob: FC<HotelTransactionDetailsLayoutProps> = ({ data, hotelDetails, payment, rateConditions }) => {
  return (
    <div className="flex w-full flex-col gap-6 pb-36">
      <BookingSummary cardData={getHotelBookingSummaryCardData(data)} dataMap={hotelOrderDataMap} />
      {hotelDetails && <HotelDetailsCard data={hotelDetails} />}
      <HotelPoliciesCard rateConditions={rateConditions} />
      <HotelPaymentDrawer payment={payment} />
    </div>
  );
};

export default HotelTransactionDetailsMob;
